import { Routing } from "helpers/routing";
import { createContext } from "react";

const TournamentStageDatasourceIdentifierContext = createContext<{
  params?: Routing.TournamentStageDatasourceIdentifiersParams
}>({})

export { TournamentStageDatasourceIdentifierContext }
